import { render, staticRenderFns } from "./ActiveOrder.vue?vue&type=template&id=79842734&scoped=true&"
import script from "./ActiveOrder.vue?vue&type=script&lang=js&"
export * from "./ActiveOrder.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOrder.vue?vue&type=style&index=0&id=79842734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79842734",
  null
  
)

export default component.exports